let itemsData = [
{
  "sku_id": 1000271,
  "title": "锁闭阀无源锁",
  "sub_title": "适用于热力锁闭阀",
  "ali_image": require('@/assets/img/item/902befd5f32a8caf4ca79b55d39ee25a.jpg'),
  "model": 'CG-VL-01',
  "ali_images": [
    {'image':require('@/assets/img/products/valve/valve/valve1.jpg')},
  ],
  'tech':[
    '锁芯双重加密',
    '每次开锁，密文随机变化，防止技术开锁',
    '防水、防湿，耐氧化设计，适合供暖锁闭阀，供水锁闭阀',
    '黄铜外壳，锌合金锁芯',
    '工作温度－30℃—70℃',
  ],
 'pdf_url':''
}
]

export default itemsData



// WEBPACK FOOTER //
// ./src/lib/valvesDetailData.js